import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import { WelcomeBox, WindowTitle } from '@homeviews/shared-ui'
import { LoginForm } from '@homeviews/auth'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
)

const Login: FC = () => {
  const classes = useStyles()

  return (
    <>
      <WindowTitle title="Login" />
      <div className={classes.root}>
        <WelcomeBox title="Sign in to your account">
          <LoginForm />
        </WelcomeBox>
      </div>
    </>
  )
}

export default Login
